import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./auth/Auth";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
const persistConfig = {
	key: "root",
	storage,
};

const persistedReducer = persistReducer(persistConfig, AuthReducer);
const store = configureStore({
	reducer: { auth: persistedReducer },
});
const persistor = persistStore(store);
export { store, persistor };
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
